import React, { useContext, useEffect, useState } from "react";
// Soft UI Dashboard PRO React example components

import Carousel from "components/UpStyled/Carousel";
import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import Checkbox from "@mui/material/Checkbox";

// Overview page components
import Header from "pages/ma/profile/components/Header";
import ProjectRequirement from "pages/ma/profile/components/ProjectRequirement";
import ServicesWeOffer from "pages/ma/profile/components/ServicesWeOffer";
import OurSpecialties from "pages/ma/profile/components/OurSpecialties";
import AboutOurCompany from "pages/ma/profile/components/AboutOurCompany";
import Gallery from "pages/ma/profile/components/Gallery";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { AccountContext } from "context/account";
import { StoreContext } from "context/store";
import { useParams, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import qs from "query-string";
import { decodeToken } from "react-jwt";
import PasswordChecklist from "react-password-checklist";
import api from "services/api";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import moment from "moment";
import { externalLinks } from "utils/data";

const Profile = (data) => {
  let { userId } = useParams();
  let location = useLocation();
  const navigate = useNavigate();

  const url = location.href ? location.href : location.pathname + location.search;
  const { register, handleSubmit, reset } = useForm({});

  const urlObj = qs.parseUrl(url);
  let token = urlObj?.query.token;
  let tokenObj = null;
  try {
    tokenObj = decodeToken(token);
  } catch (e) {
    token = null;
  }

  const [user, setUser] = useState({});
  const [agreement, setAgreement] = useState(true);
  const account = useContext(AccountContext);
  const { retriveStore, listStoreTags } = useContext(StoreContext);

  const { account_status, first_name, last_name, email } = user;
  const store = user.stores && user.stores.length > 0 ? user.stores[0] : { tags: [] };
  if (!store["metadata"]) {
    store["metadata"] = {
      address: {},
      service: [],
      reviews: [],
      following: [],
      follower: [],
    };
  }
  const [claimVisible, setClaimVisible] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [isValidPassword, setIsValidPassword] = useState(false);
  const [isChangeEmail, setIsChangeEmail] = useState(false);

  const [claimSuccessMessageVisible, setClaimSuccessMessageVisible] = useState(false);
  const [countDown, setCountDown] = useState(5);

  useEffect(() => {
    retriveUser(token);
  }, []);

  useEffect(() => {
    reset({
      first_name_input: first_name ? first_name : "",
      last_name_input: last_name ? last_name : "",
      email: email,
      name: store.name,
      story: store.story,
      new_password: "",
      confirm_password: "",
    });
  }, [user]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!claimVisible && account_status == "init") {
        setClaimVisible(true);
      }
    }, 5000);

    return () => clearTimeout(delayDebounceFn);
  }, [account_status]);

  useEffect(() => {
    if (claimSuccessMessageVisible == true) {
      const delayRedirecteFn = setInterval(() => {
        const newCount = countDown - 1;
        setCountDown(newCount);
      }, 1000);
      if (countDown <= 0) {
        navigate("/edit-profile");
      }
      return () => clearTimeout(delayRedirecteFn);
    }
  }, [countDown, claimSuccessMessageVisible]);

  const handleSetAgremment = () => setAgreement(!agreement);

  const retriveUser = async (token) => {
    try {
      const {
        data: { user },
      } = await api.invites.getUser(token);

      setUser(user);
    } catch (err) {
      console.log(err);
    }
  };

  const handleShowClaimModal = () => {
    setClaimVisible(true);
  };

  const submitClaim = async (data) => {
    if (data["new_password"] != data["confirm_password"]) {
      return toast.error("The two passwords that you entered do not match!");
    }
    if (!isValidPassword) {
      return toast.error("Your password is invalid!");
    }
    const urlObj = qs.parseUrl(url);
    const token = urlObj?.query.token;

    if (!token) {
      return toast.error("No claim token found in url!");
    }

    try {
      const userConfig = {
        first_name: data["first_name_input"],
        last_name: data["last_name_input"],
        password: data["new_password"],
        email: tokenObj["user_email"],
        stores: [
          {
            name: data["name"],
            // story: data["story"],
          },
        ],
      };
      const params = {
        token: token,
        user: userConfig,
      };

      if (isChangeEmail) {
        if (data["new_email"] != data["confirm_new_email"]) {
          return toast.error("The two emails that you entered do not match!");
        }
        params["new_email"] = data["new_email"];
      }

      await api.invites.accept(params);
      if (isChangeEmail) {
        await account.handleLogin({ email: data["new_email"], password: data["new_password"] });
      } else {
        await account.handleLogin({
          email: tokenObj["user_email"],
          password: data["new_password"],
        });
      }
      await retriveStore();
      //await listStoreTags();
      toast.success("Welcome to UpStyled!");
      setClaimVisible(false);
      setClaimSuccessMessageVisible(true);
      return;
    } catch (err) {
      if (err?.response?.data?.code == "23505") {
        return toast.error("This email address is already being used!");
      }
      console.log(err);
      return toast.error("Claim your account failed!");
    }
  };

  if (!tokenObj || tokenObj.user_email != user.email) {
    return (
      <div className="h-[100vh] flex flex-col gap-y-2 text-center items-center justify-center">
        <span className="inter-large-semibold text-grey-90">You claim link is invalid</span>
        <span className="inter-base-regular text-grey-50 mt-2">
          Please try to contact support@upstyled.co
        </span>
      </div>
    );
  } else if (tokenObj && tokenObj.exp < moment().unix()) {
    return (
      <div className="h-[100vh] flex flex-col gap-y-2 text-center items-center justify-center">
        <span className="inter-large-semibold text-grey-90">
          You claim link was expired at {moment.unix(tokenObj.exp).format("YYYY-MM-DD HH:mm:ss")}
        </span>
        <span className="inter-base-regular text-grey-50 mt-2">
          Please try to contact support@upstyled.co
        </span>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="h-[100vh] flex flex-col gap-y-2 text-center items-center justify-center">
        <span className="inter-large-semibold text-grey-90">User does not exist</span>
      </div>
    );
  }
  if (account_status != "init") {
    return (
      <div className="h-[100vh] flex flex-col gap-y-2 text-center items-center justify-center">
        <span className="inter-large-semibold text-grey-90">You already claimed your profile</span>
        <span className="inter-base-regular text-grey-50 mt-2">
          <Link to={"/login"}>Click the link to login</Link>
        </span>
      </div>
    );
  }

  const statusBar = (
    <div className="ml-8">
      <SuiButton size="small" color="info" onClick={handleShowClaimModal}>
        Claim
      </SuiButton>
    </div>
  );

  return (
    <div>
      <Header store={store} hideButton={true} statusBar={statusBar} editable={false} />
      <div className="px-4">
        <SuiBox mt={5} mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={7.5} lg={7.5}>
              <AboutOurCompany store={store} tags={[]} editable={false} account={user} />
              <Grid container spacing={3} mt={4}>
                <Grid item xs={12} sm={12} md={5} lg={5}>
                  <ProjectRequirement store={store} editable={false} />
                </Grid>
                <Grid item xs={12} sm={12} md={7} lg={7}>
                  <OurSpecialties store={store} editable={false} />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={4.5} lg={4.5}>
              <ServicesWeOffer store={store} editable={false} />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Gallery store={store} editable={false}></Gallery>
            </Grid>
          </Grid>
        </SuiBox>
      </div>
      {claimVisible ? (
        <Dialog
          open={claimVisible}
          onClose={() => setClaimVisible(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="sm"
          fullWidth={true}
        >
          <DialogTitle id="alert-dialog-title">Welcome to UpStyled</DialogTitle>

          <DialogContent>
            <SuiTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
              verticalAlign="middle"
              sx={{ whiteSpace: "nowrap", padding: "14px 0" }}
            >
              Please claim your account and setup your new password.
            </SuiTypography>

            <SuiBox component="form" py={3} onSubmit={handleSubmit(submitClaim)}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                  <SuiBox
                    display="flex"
                    flexDirection="column"
                    justifyContent="flex-end"
                    height="100%"
                  >
                    <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                      <SuiTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        required
                        textTransform="capitalize"
                      >
                        business name
                      </SuiTypography>
                    </SuiBox>
                    <SuiInput
                      placeholder="Business Name"
                      {...register("name", { required: true })}
                    />
                  </SuiBox>
                </Grid>
                {isChangeEmail ? (
                  <Grid item xs={12} sm={12}>
                    <SuiBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                          required
                        >
                          New email
                        </SuiTypography>
                      </SuiBox>
                      <SuiBox key={"new_email"} display="flex" gap={1}>
                        <SuiInput
                          type="email"
                          required
                          placeholder="New Email"
                          {...register("new_email")}
                        />
                        <SuiButton
                          size="medium"
                          variant="contained"
                          color="info"
                          type="button"
                          onClick={() => setIsChangeEmail(!isChangeEmail)}
                        >
                          Cancel
                        </SuiButton>
                      </SuiBox>
                    </SuiBox>
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={12}>
                    <SuiBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          required
                          textTransform="capitalize"
                        >
                          Email
                        </SuiTypography>
                      </SuiBox>
                      <SuiBox key={"email"} display="flex" gap={1}>
                        <SuiInput
                          placeholder="Email"
                          type="email"
                          readOnly
                          {...register("email", { required: true })}
                        />

                        <SuiButton
                          size="medium"
                          variant="contained"
                          color="info"
                          type="button"
                          onClick={() => setIsChangeEmail(!isChangeEmail)}
                        >
                          Change
                        </SuiButton>
                      </SuiBox>
                    </SuiBox>
                  </Grid>
                )}
                {isChangeEmail ? (
                  <Grid item xs={12} sm={12}>
                    <SuiBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                          required
                        >
                          confirm your new email
                        </SuiTypography>
                      </SuiBox>

                      <SuiInput
                        required
                        type="email"
                        placeholder="Confirm Email"
                        {...register("confirm_new_email")}
                      />
                    </SuiBox>
                  </Grid>
                ) : null}

                <Grid item xs={12} sm={6}>
                  <SuiBox
                    display="flex"
                    flexDirection="column"
                    justifyContent="flex-end"
                    height="100%"
                  >
                    <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                      <SuiTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        textTransform="capitalize"
                      >
                        First Name
                      </SuiTypography>
                    </SuiBox>

                    <SuiInput placeholder="First Name" {...register("first_name_input")} />
                  </SuiBox>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <SuiBox
                    display="flex"
                    flexDirection="column"
                    justifyContent="flex-end"
                    height="100%"
                  >
                    <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                      <SuiTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        textTransform="capitalize"
                      >
                        Last Name
                      </SuiTypography>
                    </SuiBox>
                    <SuiInput placeholder="Last Name" {...register("last_name_input")} />
                  </SuiBox>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <SuiBox
                    display="flex"
                    flexDirection="column"
                    justifyContent="flex-end"
                    height="100%"
                  >
                    <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                      <SuiTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        textTransform="capitalize"
                        required
                      >
                        Password
                      </SuiTypography>
                    </SuiBox>

                    <SuiInput
                      placeholder="Password"
                      autoComplete="new-password"
                      type="password"
                      required
                      {...register("new_password")}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                  </SuiBox>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <SuiBox
                    display="flex"
                    flexDirection="column"
                    justifyContent="flex-end"
                    height="100%"
                  >
                    <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                      <SuiTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        textTransform="capitalize"
                        required
                      >
                        Confirm your password
                      </SuiTypography>
                    </SuiBox>
                    <SuiInput
                      placeholder="Confirm Password"
                      type="password"
                      required
                      {...register("confirm_password")}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </SuiBox>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <SuiBox display="flex" alignItems="center">
                    <Checkbox checked={agreement} onChange={handleSetAgremment} />
                    <SuiTypography
                      variant="button"
                      fontWeight="regular"
                      onClick={handleSetAgremment}
                      sx={{ cursor: "pointer", userSelect: "none" }}
                    >
                      &nbsp;&nbsp;I agree the&nbsp;
                    </SuiTypography>
                    <SuiTypography variant="button" color="secondary">
                      <a href={externalLinks["terms-of-service"]} target="_blank">
                        Terms of service
                      </a>
                    </SuiTypography>
                    &nbsp;and&nbsp;
                    <SuiTypography variant="button" color="secondary">
                      <a href={externalLinks["privacy-policy"]} target="_blank">
                        Privacy Policy
                      </a>
                    </SuiTypography>
                  </SuiBox>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div>
                    <PasswordChecklist
                      rules={["minLength", "number", "match"]}
                      minLength={8}
                      value={newPassword}
                      valueAgain={confirmPassword}
                      iconSize={9}
                      style={{ fontSize: 12 }}
                      onChange={(isValid) => {
                        setIsValidPassword(isValid);
                      }}
                    />
                  </div>
                </Grid>
              </Grid>
              <SuiBox
                pt={3}
                px={3}
                display="flex"
                justifyContent="end"
                alignItems={{ xs: "flex-start", sm: "center" }}
                flexDirection={{ xs: "column", sm: "row" }}
              >
                <SuiBox display="flex" flexDirection={{ xs: "column", sm: "row" }}>
                  <SuiBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>
                    <SuiButton
                      variant="gradient"
                      size="medium"
                      className="mr-2"
                      color="light"
                      onClick={() => setClaimVisible(false)}
                    >
                      Cancel
                    </SuiButton>
                  </SuiBox>
                </SuiBox>
                <SuiBox display="flex" flexDirection={{ xs: "column", sm: "row" }}>
                  <SuiBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>
                    <SuiButton size="medium" variant="gradient" color="dark" type="submit">
                      Claim
                    </SuiButton>
                  </SuiBox>
                </SuiBox>
              </SuiBox>
            </SuiBox>
          </DialogContent>
        </Dialog>
      ) : null}
      {claimSuccessMessageVisible ? (
        <Dialog
          open={claimSuccessMessageVisible}
          onClose={() => setClaimSuccessMessageVisible(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="sm"
          fullWidth={true}
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <div className="h-[200px] flex flex-col gap-y-2">
                <div className="inter-large-semibold text-grey-90">
                  Your profile has been claimed successfully!
                </div>
                <div className="inter-base-regular text-grey-50 mt-2">
                  We will redirect you to edit profile page in {countDown} seconds...
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      ) : null}
    </div>
  );
};

export default Profile;
